import { EmployeeProfilesListTranslation } from '@/assets/locales/views/employeeProfilesList/employeeProfilesSearch.translation.en';

export const employeeProfilesListTranslation: EmployeeProfilesListTranslation = {
  form: {
    regionsSelect: {
      east: 'Wschód',
      headquarter: 'Biuro główne',
      selectAll: 'Zaznacz wszystko',
      south: 'Południe',
      west: 'Zachód',
    },
  },
};
